function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.801 31.567L.015 15.78l1.8-1.8 15.787 15.787zM1.817 17.583l-1.8-1.8L15.803-.003l1.8 1.8z",
  fill: "#fff",
  fillRule: "evenodd"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.594,
    height: 31.563
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy41OTQiIGhlaWdodD0iMzEuNTYzIiB2aWV3Qm94PSIwIDAgMTcuNTk0IDMxLjU2MyI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJBcnJvdyIgY2xhc3M9ImNscy0xIiBkPSJNMjk3Ljk1Nyw2NjAuNDQybC0xNS43ODYtMTUuNzg3LDEuOC0xLjgsMTUuNzg3LDE1Ljc4N1ptLTEzLjk4NC0xMy45ODQtMS44LTEuOCwxNS43ODYtMTUuNzg2LDEuOCwxLjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjgyLjE1NiAtNjI4Ljg3NSkiLz4KPC9zdmc+Cg==";
export { SvgArrowLeft as ReactComponent };